// extracted by mini-css-extract-plugin
export default {"list":"Memo__list--eo+Ts","item":"Memo__item--+6HjH","title":"Memo__title--VgBj3","meta":"Memo__meta--ZrV83","empty":"Memo__empty--bMJW6"};